import React, { memo } from 'react';

import { GADataType, IsDisabled } from '../../../types';
import { FiltersProps, useFilters } from '../hooks/useFilters';

import {
  ColorsSelect,
  ColorsSelectItemValue,
  ColorsSelectDataItem
} from '../../ColorsSelect';

type ColorsSelectFilterValue = ColorsSelectItemValue[] | undefined;

interface ColorsSelectFilterProps
  extends FiltersProps<ColorsSelectFilterValue> {
  items: ColorsSelectDataItem[];
  disabled?: IsDisabled;
}

function ColorsSelectFilter({
  dataGa,
  name,
  value,
  items,
  disabled,
  onChange
}: ColorsSelectFilterProps & GADataType) {
  const { updatedValue, handleChange } = useFilters<ColorsSelectFilterValue>({
    name,
    value,
    emptyValue: [],
    onChange
  });

  return (
    <ColorsSelect
      dataGa={dataGa}
      isMulti
      items={items}
      value={updatedValue}
      disabled={disabled}
      onChange={handleChange}
    />
  );
}

export default memo(ColorsSelectFilter);
